export const cssBundleHref = "https://cx-resources.oddschecker.com/public/build/css-bundle-7IFIWQO5.css";